import React from 'react';
import { Shield, MessageSquare, Mail } from 'lucide-react';
export function PrivacyStatement() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1221">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1222">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1223">
          <div className="flex items-center justify-center mb-4" data-id="element-1224">
            <Shield className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1225" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1226">
              Privacy Statement
            </h1>
          </div>
        </div>

        {/* General Privacy Statement */}
        <div className="prose prose-lg max-w-none mb-12" data-id="element-1227">
          <p className="text-base leading-relaxed text-gray-700" data-id="element-1228">
            By registering with Desert Sage Seminars, you will create an account
            by which we may provide you with quality ON-Line real estate license
            renewal classes. Your information will be kept confidential and not
            shared with any other party. The Arizona Department of Real Estate
            requires that we confirm your information and that you are the
            person taking the classes. We will ask you to affirm that each time
            you begin a class. Impersonating a real estate licensee is subject
            to forfeiture of the real estate license for either or both parties.
            Payments you make for our classes are made through a 3rd party
            merchant account secured by our site, and they do not share your
            credit card information with us or any other party.
          </p>

          <p className="text-base leading-relaxed text-gray-700 mt-6" data-id="element-1229">
            All the payment information we collect is done so under SSL – a
            standard internet security measure. Any data that we store about you
            is kept behind a secure firewall in our database and is not
            accessible to the public in any way. Any requests by an outside
            party for informaton about you or your account will be denied except
            for any request from the Arizona Department of Real Estate, or any
            other regulatory agency empowered to investigate your real estate
            activity.
          </p>
        </div>

        {/* Text Messaging Privacy Policy */}
        <div className="border-t-2 border-gray-200 pt-12" data-id="element-1230">
          <div className="flex items-center mb-6" data-id="element-1231">
            <MessageSquare className="w-8 h-8 text-brand-purple-600 mr-3" data-id="element-1232" />
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-1233">
              Text Messaging Privacy Policy:
            </h2>
          </div>

          <div className="bg-gray-50 rounded-lg p-6 mb-8" data-id="element-1234">
            <p className="text-base leading-relaxed text-gray-700" data-id="element-1235">
              This Text Message Text Messaging Privacy Policy Addendum is a
              legal agreement between Desert Sage Seminars ("Desert Sage
              Seminars" "Company", "we", "our", or "us") and you that
              supplements our Privacy Policy, available by specifically
              describing our privacy practices in connection with your use of
              our SMS messaging program (the "Platform"). In the event of any
              conflict between the Text Messaging Privacy Policy Addendum and
              the Privacy Policy in relation to the subject matter provided
              herein, the Text Messaging Privacy Policy Addendum shall take
              precedent.
            </p>
          </div>

          {/* Terms Section */}
          <div className="mb-8" data-id="element-1236">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1237">Terms</h3>

            <div className="space-y-6" data-id="element-1238">
              <p className="text-base leading-relaxed text-gray-700" data-id="element-1239">
                Under no circumstances will Desert Sage Seminars sell or share
                your name, mobile telephone number, or other personal
                information with third-parties or affiliates for marketing or
                promotional purposes.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1240">
                Under no circumstances will Desert Sage Seminars purchase or use
                your name and mobile telephone number collected from third
                parties.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1241">
                You can cancel the SMS service at any time. Just text "STOP" to
                the number or short code that sent you the message. After you
                send the SMS message "STOP" to us, we will send you an SMS
                message to confirm that you have been unsubscribed. After this,
                you will no longer receive SMS messages from us. If you want to
                join again, just sign up as you did the first time and we will
                start sending SMS messages to you again.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1242">
                Carriers are not liable for delayed or undelivered messages.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1243">
                You will receive messages with info, promotions, and offers to
                the number(s) you have provided, including use of an automated
                system.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1244">
                Message frequency varies.
              </p>

              <p className="text-base leading-relaxed text-gray-700" data-id="element-1245">
                As always, message and data rates may apply for any messages
                sent to you from us and to us from you. If you have any
                questions about your text plan or data plan, it is best to
                contact your wireless provider.
              </p>
            </div>
          </div>

          {/* Contact Us Section */}
          <div className="bg-brand-purple-50 rounded-lg p-8 border border-brand-purple-100" data-id="element-1246">
            <div className="flex items-center mb-4" data-id="element-1247">
              <Mail className="w-6 h-6 text-brand-purple-600 mr-3" data-id="element-1248" />
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-1249">Contact Us</h3>
            </div>

            <p className="text-base leading-relaxed text-gray-700 mb-4" data-id="element-1250">
              If you have any questions or feedback relating to these Text
              Messaging Privacy Policy Addendum, or need any help, please
              contact us via email at{' '}
              <a href="mailto:support@DesertSageSeminars.com" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold" data-id="element-1251">
                support@DesertSageSeminars.com
              </a>
            </p>

            <p className="text-base leading-relaxed text-gray-700" data-id="element-1252">
              You may also text HELP for help at any time.
            </p>
          </div>
        </div>
      </div>
    </div>;
}